const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:1337'

const config = {
  Oauth2: {
    clientId: '77s1wlmrmf0zi5',
    authCalbackURI: `${API_URL}/user/linkedin_authenticate`,
    state: 'SHZiQXBw',
    scope: [ 'r_fullprofile', 'r_emailaddress' ]
  },
  SERVER_URL: API_URL,
  DEMO_EMAIL: 'test@hvb.ch'
}

export default config



// WEBPACK FOOTER //
// ./src/config.js